import jump from 'jump.js'
import {searchurl} from '@/js/components/searchurl.js'
const menu = document.querySelector('.mainmenu')

if (menu) {

    const solucionesPage = document.querySelector('.soluciones#page')
    const allianceBTNs = document.querySelectorAll('.btn_alliance')
    const trackBTNs = document.querySelectorAll('.btn_track')
    const inmuneBTNs = document.querySelectorAll('.btn_inmune')
    const bgcBTNs = document.querySelectorAll('.btn_bgc')
    const url = document.querySelector('#urlsol')
    let sol
    // console.log('sub');
    // if (lang == "en-US"){
    //     sol = '/soluciones'
    // } else {
    //     sol = 'solutions/'
    // }
    // const lang = document.documentElement.lang
  

    allianceBTNs.forEach(btn => { btn.addEventListener("click", (e) => {desplaza(e, '#alliance_jump', 'alliance') }) }) ;
    trackBTNs.forEach(btn => { btn.addEventListener("click", (e) =>  {desplaza(e, '#track_jump', 'track') }) });
    inmuneBTNs.forEach(btn => { btn.addEventListener("click", (e) =>  {desplaza(e, '#inmune_jump', 'inmune') }) });
    bgcBTNs.forEach(btn => { btn.addEventListener("click", (e) =>  {desplaza(e, '#bgc_jump', 'bgc') }) });



    function desplaza(e,link, param){
        if(e){
            e.preventDefault()
        }
        
        if(solucionesPage){
        jump(link, {
            offset: -400
          })
        } else {
          
            window.open(url.value + '?li=' + param, '_SELF')
        }
    }

    if(searchurl().li){
        if(searchurl().li == 'alliance') { desplaza (false, '#alliance_jump', 'alliance')}
        if(searchurl().li == 'track') { desplaza (false, '#track_jump', 'track')}
        if(searchurl().li == 'inmune') { desplaza (false, '#inmune_jump', 'inmune')}
        if(searchurl().li == 'bgc') { desplaza (false, '#bgc_jump', 'bgc')}
    }
}
